import { render, staticRenderFns } from "./selectRegion.vue?vue&type=template&id=b05cd948&scoped=true"
import script from "./selectRegion.vue?vue&type=script&lang=js"
export * from "./selectRegion.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=b05cd948&prod&scoped=true&lang=css&external"
import style1 from "./selectRegion.vue?vue&type=style&index=1&id=b05cd948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05cd948",
  null
  
)

export default component.exports